var render, staticRenderFns
import script from "./map_form_place.vue?vue&type=script&lang=js"
export * from "./map_form_place.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ddd0fcd')) {
      api.createRecord('5ddd0fcd', component.options)
    } else {
      api.reload('5ddd0fcd', component.options)
    }
    
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/sign_group/form/components/map_form_place.vue"
export default component.exports